module.exports = __webpack_public_path__ + "img/awaitingAudit.5cbf88a3.png";